import { ReverseAddressesFormComponent } from './addresses-form/reverse-addresses-form.component';

/* globals angular, _, $ */
(function() {
  'use strict';

  function ReverseFormCtrl(
    $scope,
    $rootScope,
    $mdToast,
    $uibModal,
    $state,
    $stateParams,
    Historico,
    Pedido,
    Perfil,
    localStorageService) {

    $rootScope.msgSuccessReverse = false;

    Date.prototype.addDays = function(days) {
      var dat = new Date(this.valueOf());
      dat.setDate(dat.getDate() + days);
      return dat;
    }

    var vm = this;
    vm.canShowOptions = false;
    vm.reverse = {
      remetente: {
        endereco: {}
      }
    }

    // Set init state
    vm.original = {
      packageId: null,
      orderId: null,
    };

    vm.deliveryTypes = [];
    vm.selectedDeliveryType = null;
    vm.declaredValue = null;

    function _init() {
      if($stateParams.originalPackageId && $stateParams.originalOrderId) {
        vm.original.packageId = $stateParams.originalPackageId;
        vm.original.orderId = $stateParams.originalOrderId;
      }

      _getUserAddresses();
    }

    vm.reset = function () {
      vm.reverse = {
        remetente: {
          endereco: {}
        },
        deliveryType: null,
        comSeguro: false,
        valorDeclarado: null,
        comEmbalagem: false,
      }
    }

    vm.setDeliveryType = function(deliveryType) {
      vm.selectedDeliveryType = deliveryType;
    }

    vm.setDeclaredValue = function(value) {
      vm.declaredValue = value;
    }

    vm.canShowOptionsChange = (x) => { vm.canShowOptions = x }

    vm.deliveryTypesChange = function(values) {
      vm.deliveryTypes = values.map(x => x.toJSON());
    }

    vm.save = function() {

      vm.optionsFormSubmitted = true;

      if (!vm.selectedDeliveryType) {
        _showAlert("Ops, alguns campos não foram preenchidos corretamente");
        return;
      }

      vm.salvandoOn = true;

      vm.optionsFormSubmitted = false;
      vm.reverse.tipoEntrega = vm.selectedDeliveryType.tipo;
      vm.reverse.valorDeclarado = vm.declaredValue;

      vm.reverse.remetente.endereco.codigoPostal = vm.reverse.remetente.endereco.codigoPostal.replace(/-/g, '');
      vm.reverse.remetente.endereco.pais = "Brasil";
      vm.reverse.destino.codigoPostal = vm.reverse.destino.codigoPostal.replace(/-/g, '');
      vm.reverse.destino.pais = "Brasil";
      vm.reverse.destinatario = {
        nome: vm.reverse.destino.nome,
        email: vm.user.email,
        endereco: vm.reverse.destino
      }

      vm.reverse.original = vm.originalPackage;

      Historico.saveReverse(vm.reverse)
      .then(function(data) {
        $rootScope.msgSuccessReverse = true;
        vm.salvandoOn = false;
        _showModalReverseAlert();
      })
      .catch(function(err){
        vm.salvandoOn = false;

        if(err.status == '422' && err.data.error && err.data.error.code == 'validation.constraints.cpf'){
          _showAlert("Ops, o documento informado é inválido");
        } else {
          _showAlert("Ops, não foi possível criar a reversa");
        }
      });
    }

    function _showModalReverseAlert() {
      if(localStorageService.cookie.get('checkAlertReverseCheck') == true) {
        $state.go("reverse-list");
        return;
      }

      $uibModal.open({
        animation: false,
        templateUrl: 'modalReverseAlert.html',
        controller: 'ReverseAlertCtrl',
        controllerAs: 'vm',
        resolve: {
          id: function() {return 'empty';}
        }
      })
      .result
      .then(function(data) {
          $state.go("reverse-list");
      });
    }

    function _getUserAddresses() {
      Perfil.getUserData()
      .then(function(user) {
        vm.user = user;
        vm.recipients = user.enderecos
        .filter(function(recipient) { return recipient.logisticaReversaHabilitada == true; })
        .map(function(recipient) { return Object.assign(recipient, { codigoPostal: recipient.cep }); });
      })
      .catch(function(err) {
        _showAlert("Não foi possível carregar os do seu usuário");
      });
    }

    function _showAlert(content) {
      var toast = $mdToast.simple()
        .textContent(content)
        .highlightAction(true)
        .parent('[data-container="toast"]')
        .position('top right')
        .hideDelay(5000);

      return $mdToast.show(toast);
    }

    _init();

    $scope.$watch('addressesForm.$valid', function(validity) {
      vm.addressesFormValid = validity;
      vm.allFormValid = vm.addressesFormValid && vm.optionsFormValid;
    });

    $scope.$watch('optionsForm.$valid', function(validity) {
      vm.optionsFormValid = validity;
      vm.allFormValid = vm.addressesFormValid && vm.optionsFormValid;
    });

    vm.cancel = function() {
      $uibModal.open({
        animation: false,
        template: require('./cancel-panel/cancel-panel.html'),
        controller: 'ReverseCancelCtrl',
        controllerAs: 'vm',
        windowClass: 'cancel-panel',
        resolve: {
          id: function() {return 'empty';}
        }
      })
      .result
      .then(function(data) {
          $state.go("reverse-list");
      });
    }
  }

  function ReverseAlertCtrl($scope, $rootScope, $state, $uibModalInstance, localStorageService) {

    var vm = this;

    vm.confirm = function () {
        $uibModalInstance.close({});
    };

    vm.dontShowAgain = function(alert) {
      if (localStorageService.cookie.get(alert) == null) {
        localStorageService.cookie.set(alert, true);
      } else if (localStorageService.cookie.get(alert) === true) {
        localStorageService.cookie.remove(alert);
      }
    }
  }

  angular
    .module('mandaeApp')
    .component(ReverseAddressesFormComponent.componentName, ReverseAddressesFormComponent)
    .controller('ReverseAlertCtrl', ReverseAlertCtrl)
    .controller('ReverseFormCtrl', ReverseFormCtrl);

}());
